import {
  Create,
  FormTab,
  TabbedForm,
  TextInput,
  BooleanInput,
  required,
  SelectInput,
  ReferenceInput,
  useGetIdentity,
  TopToolbar,
  ListButton,
} from 'react-admin'
import * as React from 'react'
import * as PropTypes from 'prop-types'

const WsCampaignCreateActions = ({ basePath }) => (
  <TopToolbar>
    <ListButton basePath={basePath} />
  </TopToolbar>
)

WsCampaignCreateActions.propTypes = {
  basePath: PropTypes.any,
}

export const WsCampaignsCreate = props => {
  const { loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  return (
    <Create actions={<WsCampaignCreateActions />} {...props}>
      <TabbedForm
        submitOnEnter={false}
        syncWithLocation={false}
        redirect="edit"
      >
        <FormTab label="Summary">
          <ReferenceInput
            label="Campaigns"
            source="campaign_id"
            reference="campaigns"
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
          <TextInput
            source="url_ws"
            validate={required()}
            style={{
              width: '100%',
              height: '60px',
            }}
          />
          <BooleanInput
            source="status"
            defaultValue={false}
            format={value => value === 1}
            parse={value => (value ? 1 : 0)}
          />
        </FormTab>
      </TabbedForm>
    </Create>
  )
}
